import styled from 'styled-components'
import { Link } from 'react-router-dom';

export const MemberLink = styled(Link)`
  font-family: 'Aref Ruqaa', serif;
  color: #73A942;
  text-decoration: none;
  padding: 0.5rem 1rem;
  height: 100%;

&:hover {
      color: #245501;
      transition: all 0.3s ease;
    }
  @media screen and (max-width: 1170px) {
    text-align: center;
    padding: 2rem;
    width: 100%;
    display: table;  
  }
`;

export const MemberLinkBtn = styled(Link)`
  margin : 3px;
  border-radius: 22px;
  border : 1px solid #538D22;
  background-color: white;
  color: #538D22;
  font-family: 'Cairo', sans-serif;
  white-space: nowrap;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  font-weight : bold;

  transition-duration: 0.4s;
  cursor: pointer;

  &:hover {
    transition: all 0.3s ease-out;
    color: white;
    background-color: #538D22;
  }

`;




export const MemberLinkBtnOrangeDark = styled(Link)`
  margin : 3px;
  border-radius: 22px;
  border : 1px solid #f95738;
  background-color: white;
  color: #f95738;
  font-family: 'Cairo', sans-serif;
  white-space: nowrap;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  font-weight : bold;

  transition-duration: 0.4s;
  cursor: pointer;

  &:hover {
    transition: all 0.3s ease-out;
    color: white;
    background-color: #f95738;
  }

`;





export const MemberLinkBtnBlue = styled(Link)`
  margin : 3px;
  border-radius: 22px;
  border : 1px solid #4682B4;
  background-color: white;
  color: #4682B4;
  font-family: 'Cairo', sans-serif;
  white-space: nowrap;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  font-weight : bold;

  transition-duration: 0.4s;
  cursor: pointer;

  &:hover {
    transition: all 0.3s ease-out;
    color: white;
    background-color: #4682B4;
  }

`;





export const MemberLinkBtnBordo = styled(Link)`
  margin : 3px;
  border-radius: 22px;
  border : 1px solid #CC0000;
  background-color: white;
  color: #CC0000;
  font-family: 'Cairo', sans-serif;
  white-space: nowrap;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  font-weight : bold;

  transition-duration: 0.4s;
  cursor: pointer;

  &:hover {
    transition: all 0.3s ease-out;
    color: white;
    background-color: #CC0000;
  }

`;


export const MemberLinkBtnPink = styled(Link)`
  margin : 3px;
  border-radius: 22px;
  border : 1px solid #ff4081;
  background-color: white;
  color: #ff4081;
  font-family: 'Cairo', sans-serif;
  white-space: nowrap;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  font-weight : bold;

  transition-duration: 0.4s;
  cursor: pointer;

  &:hover {
    transition: all 0.3s ease-out;
    color: white;
    background-color: #ff4081;
  }

`;




export const MemberLinkBtnDeepLilac = styled(Link)`
  margin : 3px;
  border-radius: 22px;
  border : 1px solid #9e63af;
  background-color: white;
  color: #9e63af;
  font-family: 'Cairo', sans-serif;
  white-space: nowrap;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  font-weight : bold;

  transition-duration: 0.4s;
  cursor: pointer;

  &:hover {
    transition: all 0.3s ease-out;
    color: white;
    background-color: #9e63af;
  }

`;



export const MemberLinkBtnGold = styled(Link)`
  margin : 3px;
  border-radius: 22px;
  border : 1px solid #e9c46a;
  background-color: white;
  color: #e9c46a;
  font-family: 'Cairo', sans-serif;
  white-space: nowrap;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  font-weight : bold;

  transition-duration: 0.4s;
  cursor: pointer;

  &:hover {
    transition: all 0.3s ease-out;
    color: white;
    background-color: #e9c46a;
  }

`;
